import { takeLatest, put, all, call, select } from 'redux-saga/effects'
import {setList, setFacets, setFilters, setFiltersTree, setCount, setFiltersSchema} from './actions'
import DataService from "../../services/DataService";

import {getConfig, getLevels, getResultsType, getSubarea} from "../settings/selectors";
import { getRecents, getFavorites } from "../auth/selectors";
import {setLevels} from "../settings/actions";
import {getCount} from "./selectors";
import {omit} from "lodash";
import {DOMAINS} from "./../../domains";
import RecentsService from "../../services/RecentsService";

function* setListSaga({ payload }) {

  const config = yield select(getConfig);
  let subarea = payload.hasOwnProperty('subarea') ? payload.subarea : yield select(getSubarea);
  subarea = (subarea && config.areas.subcompanies.subareas.hasOwnProperty(subarea) ? config.areas.subcompanies.subareas[subarea].key : null);

  try {

    let filterByIds = null;
    const resultsType = yield select(getResultsType);

    if (resultsType === 'recents') {
      const recents = yield call([RecentsService, 'getList'], 'subcompanies');
      filterByIds = recents && recents.length ? recents.map(({ itemId}) => itemId) : [];
    } else if (resultsType === 'favorites') {
      const favorites = yield select(getFavorites);
      filterByIds = favorites ? favorites.map(item => item.itemId) : [];
    } else if (resultsType === 'suggested') {
      // Non disponibili
      filterByIds = [];
    }

    if (payload.reset) {
      yield put(setList.success(Object.assign({}, {
        items: [],
        count: 0,
        page: 0,
        reset: true,
        timestamp: null,
        resetSubarea: true,
        isLoading: true
      })))
    }

    let response = yield call([DataService, 'getList'], {
      area: "subcompanies",
      subarea: subarea,
      page: payload.page,
      search: payload.search,
      filters: payload.filters,
      ids: filterByIds,
      resultsType: 'suggested',
      isLoading: false
    });

    response = Object.assign({}, {
      items: response,
      count: response.length,
      page: payload.page,
      reset: payload.reset,
      timestamp: payload.timestamp,
      resetSubarea: payload.resetSubarea,
      isLoading: false
    });

    yield put(setList.success(response))

  } catch(e) {

    yield put(setList.failure(e))

  }
}

function* setFacetsSaga({ payload }) {

  // const {field, tempFilters, reset, search} = payload;

  const subarea = yield select(getSubarea);

  try {

    let filterByIds = null;
    const resultsType = yield select(getResultsType);

    if (resultsType === 'recents') {
      const recents = yield select(getRecents);
      filterByIds = recents && recents.subcompanies ? recents.subcompanies : [];
    } else if (resultsType === 'favorites') {
      const favorites = yield select(getFavorites);
      filterByIds = favorites ? favorites.map(item => item.itemId) : [];
    } else if (resultsType === 'suggested') {
      // TODO: leggere i suggeriti
      // const recents = yield select(getFavorites);
      filterByIds = []; // recents && recents.subcompanies ? recents.subcompanies : [];
    }

    const { field, tempFilters, reset, search } = payload;
    if (reset) {

      yield put(setFacets.success({ reset: true }));

    } else {

      let filters = omit(payload.filters, [field.field]);
      const query = tempFilters ? tempFilters[Object.keys(tempFilters)[0]] : '';
      const fieldName = payload.field.hasOwnProperty('field') ? payload.field.field : payload.field;

      const args = {
        area: 'subcompanies',
        subarea: subarea,
        field: fieldName,
        filters,
        query,
        search,
        ids: filterByIds
      };

      let data = yield call([DataService, 'getFacets'], args);
      let response = {
        field: fieldName,
        data
      };

      response = Object.assign({}, response, {
        count: 0
      });

      yield put(setFacets.success(response));

    }

  } catch(e) {

    console.error(e);

  }
}
function* setFiltersSaga({ payload }) {

  try {
    yield put(setFilters.success(payload));
  } catch(e) {
    console.error(e);
  }

}

function* setFiltersTreeSaga({ payload }) {

  const levels = yield select(getLevels);
  const subarea = yield select(getSubarea)
  const filters = payload.filters;

  try {

    if(levels.indexOf(payload.facet) === -1) {

      const args = {
        area: 'subcompanies',
        subarea: subarea,
        [payload.field]: payload.facet,
        field: payload.field,
        filters,
      };

      let data = yield call([DataService, 'getFacets'], args);

      if (data && data.length) {
          let fieldName = levels.filter(item => item.indexOf('_lv') === -1).reverse()[0];
          let filteredLevels = levels.filter(item => item.indexOf(`${fieldName}_lv`) === 0)
          const newLevels = [...levels, `${fieldName}_lv${filteredLevels.length + 1}`];
          yield put(setLevels.trigger({levels: [...newLevels], levelsDepth: newLevels.length}))
      }

    }

  } catch (e) {
  }

}

function* setCountSaga() {

  const count = yield select(getCount);

  if (count === null) {
    let total = 0;
    for(var subarea of Object.keys(DOMAINS[window.location.hostname].areas["subcompanies"].subareas)){
      total += yield call([DataService, 'getCount'], {
        area: "subcompanies",
        subarea: subarea
      });
    }
    yield put(setCount.success({count: total}));
  }

}

function* setFiltersSchemaSaga() {

  try {
    let data = yield call([DataService, 'getFiltersStructure'], 'subcompanies');
    yield put(setFiltersSchema.success(data));
  } catch (e) {
    yield put(setFiltersSchema.failure(e.message));
  }

}


export default function* root() {
  yield all([
    yield takeLatest([setList.TRIGGER], setListSaga),
    yield takeLatest([setFacets.TRIGGER], setFacetsSaga),
    yield takeLatest([setFilters.TRIGGER], setFiltersSaga),
    yield takeLatest([setFiltersTree.TRIGGER], setFiltersTreeSaga),
    yield takeLatest([setCount.TRIGGER], setCountSaga),
    yield takeLatest([setFiltersSchema.TRIGGER], setFiltersSchemaSaga)
  ])
}
